import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Loader, Table } from '@itds/elements/index.js';

import EditCategoryDrawer from './resources/EditCategory';
import EditLinkDrawer from './resources/EditLink';

import { Api } from '@brokerage/utils/Api';

const ResourcesList = ({ mobile_app }) => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [links, setLinks] = useState([]);
  const [category, setCategory] = useState(null);
  const [link, setLink] = useState(null);

  useEffect(() => {
    Promise.all([loadCategories(), loadLinks()]);
  }, []);

  const loadCategories = () => {
    setLoading(true);

    Api.loadMobileAppResourceCategories(mobile_app.guid).then(response => {
      const { data } = response;

      setCategories(data);
      setLoading(false);
    });
  };

  const loadLinks = () => {
    setLoading(true);

    Api.loadMobileAppResourceLinks(mobile_app.guid).then(response => {
      const { data } = response;

      setLinks(data);
      setLoading(false);
    });
  };

  const handleDelete = (id, type, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);

    if (type === 'categories') {
      Api.deleteMobileAppResourceCategory(id).then(() => {
        loadCategories();
      });
    } else {
      Api.deleteMobileAppResourceLink(id).then(() => {
        loadLinks();
      });
    }
  };

  const handleCategorySave = () => {
    setCategory(null);
    loadCategories();
  };

  const handleLinkSave = () => {
    setLink(null);
    loadLinks();
  };

  return loading ? (
    <Loader />
  ) : (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <EditCategoryDrawer
        categories={categories}
        category={category}
        onClose={setCategory.bind(null, null)}
        onSave={handleCategorySave}
        show={!!category}
      />

      <EditLinkDrawer
        categories={categories}
        link={link}
        onClose={setLink.bind(null, null)}
        onSave={handleLinkSave}
        show={!!link}
      />

      <div style={{ width: '48%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h2
            style={{
              fontSize: 20,
              marginBottom: 40,
              color: '#2F3B44',
              fontFamily: 'Quicksand'
            }}
          >
            Categories
          </h2>

          <Button
            onClick={setCategory.bind(null, { mobile_app_guid: mobile_app.guid })}
            small={true}
          >
            New Category
          </Button>
        </div>

        <Table
          columns={[
            {
              id: 'name',
              label: 'Name'
            },
            {
              id: 'parent_category_guid',
              label: 'Parent Category',
              render: category => {
                const parent_category =
                  categories.find(c => c.guid === category.parent_category_guid) || {};

                return parent_category.name || 'Top Level';
              }
            },
            {
              id: 'actions',
              render: category => {
                return (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      color='RED'
                      onClick={handleDelete.bind(null, category.guid, 'categories')}
                      small={true}
                    >
                      Delete
                    </Button>
                  </div>
                );
              }
            }
          ]}
          data={categories}
          onRowClick={setCategory}
          placeholder='No categories yet'
        />
      </div>

      <div style={{ width: '48%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h2
            style={{
              fontSize: 20,
              marginBottom: 40,
              color: '#2F3B44',
              fontFamily: 'Quicksand'
            }}
          >
            Links
          </h2>

          <Button onClick={setLink.bind(null, { mobile_app_guid: mobile_app.guid })} small={true}>
            New Link
          </Button>
        </div>

        <Table
          columns={[
            {
              id: 'name',
              label: 'Name'
            },
            {
              id: 'url',
              label: 'URL'
            },
            {
              id: 'category_guid',
              label: 'Category',
              render: link => {
                const parent_link = categories
                  ? categories.find(c => c.guid === link.category_guid)
                  : {};

                return parent_link ? parent_link.name : 'Uncategorized';
              }
            },
            {
              id: 'actions',
              render: link => {
                return (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      color='RED'
                      onClick={handleDelete.bind(null, link.guid, 'links')}
                      small={true}
                    >
                      Delete
                    </Button>
                  </div>
                );
              }
            }
          ]}
          data={links}
          onRowClick={setLink}
          placeholder='No links yet'
        />
      </div>
    </div>
  );
};

ResourcesList.propTypes = {
  mobile_app: PropTypes.object
};

export default ResourcesList;
